import React from 'react';
import { Box, Divider, Drawer, IconButton, Toolbar } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ScrollableView } from '@uplift/ui-v2';
import { PatientDetailsLayoutProps } from './types';
import { ArrowBack, ArrowForward } from '@mui/icons-material';


const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    position: 'relative',
    flex: 1,
  },
  patientDetails: {
    backgroundColor: theme.palette.common.white,
    borderRight: `1px solid ${theme.palette.divider}`,
    width: '385px',
    zIndex: theme.zIndex.appBar - 1,
  },
  activities: {
    padding: theme.spacing(6, 5),
  },
  compactAssessments: {
    borderLeft: `1px solid ${theme.palette.divider}`,
  },
  assessments: {
    borderLeft: `1px solid ${theme.palette.divider}`,

    '& > div:not(:last-child)': {
      flex: 1,
      borderBottom: `1px solid ${theme.palette.divider}`,
    }
  },
  assessmentsDrawer: {
    width: '384px',
  },
}));


export function DesktopSmallLayout(props: PatientDetailsLayoutProps) {
  const [ open, setOpen ] = React.useState(false);
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.patientDetails}>
        <ScrollableView height="100%">
          {props.patientDetails}
          {props.patientAccordions}
        </ScrollableView>
      </Box>
      <ScrollableView>
        <Box className={classes.activities}>
          {props.activities}
        </Box>
      </ScrollableView>
      <Box className={classes.compactAssessments}>
        <Box display="flex" justifyContent="center" p={1} width="100%" boxSizing="border-box">
          <IconButton onClick={() => setOpen(true)} color="secondary" size="small">
            <ArrowBack />
          </IconButton>
        </Box>
        <Divider />
        {props.compactAssessment}
      </Box>
      <Drawer
        anchor="right"
        disablePortal
        keepMounted
        open={open}
        style={{ zIndex: 0 }}
        onClose={() => setOpen(false)}
        classes={{ paper: classes.assessmentsDrawer }}
        slotProps={{
          backdrop: {
            style: { zIndex: -1 }
          }
        }}
      >
        <Toolbar />
        <Box p={1}>
          <IconButton onClick={() => setOpen(false)} color="secondary" size="small">
            <ArrowForward />
          </IconButton>
        </Box>
        <Box className={classes.assessments}>
          {props.assessments}
        </Box>
      </Drawer>
    </Box>
  );
}
